// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__QIA54","input":"Checkbox_input___ZlLO","tickBox":"Checkbox_tickBox__n9ZoL"};